import LocaleService from './localeService'
import { has, get } from 'lodash'

const LocalePlugin = {
  install: function (Vue, options) {
    // Replace the default config instance, with the loaded config instance from vueapp
    LocaleService.replaceDependency('conf', Vue.conf)
    if (has(options, 'clientLocaleBundle')) {
      LocaleService.replaceLoadedBundle('client', get(options, 'clientLocaleBundle'))
    }
    /**
     * Instance registration
     * @type {{replaceLoadedBundle, replaceDependency, getCurrentLocale, translate, getLoadedBundles}}
     */
    Vue.prototype.$locale = LocaleService
    /**
     * translateItem global method registration
     * @type {LocaleService.translate}
     */
    Vue.locale = LocaleService
    /**
     * Locale mixin
     */
    Vue.mixin({
      data: () => {
        return {
          locale: LocaleService
        }
      },
      methods: {
        t: (key, options = false) => {
          return LocaleService.translate(key, options)
        }
      }
    })
  }
}

export default LocalePlugin
